// extracted by mini-css-extract-plugin
export default {"content":"titleContentComponent_content__amYrZ","title":"titleContentComponent_title__8pXDZ","subtitle":"titleContentComponent_subtitle__pfVRq"};